module.exports = __webpack_public_path__ + "img/workspace-link-icon.ba22ffea.svg";